import { useMemo } from 'react';

import { Position, Sport } from '@sorare/core/src/__generated__/globalTypes';
import { BodyS } from '@sorare/core/src/atoms/typography';
import { useIntlContext } from '@sorare/core/src/contexts/intl';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import { isAnyHitter, isFlex, messages } from 'lib/baseball';
import { positionShortNames } from 'lib/so5';

type Props = {
  positions?: Position[];
};

export const PositionDetails = ({ positions = [] }: Props) => {
  const { sport = Sport.FOOTBALL } = useSportContext();
  const { formatMessage } = useIntlContext();

  const hint = useMemo(() => {
    if (isFlex(positions)) return formatMessage(messages.hintFlex);
    if (isAnyHitter(positions)) return formatMessage(messages.hintHitter);
    return positions.map(p => formatMessage(positionShortNames[p])).join(' - ');
  }, [positions, formatMessage]);

  if (sport === Sport.BASEBALL) {
    return (
      positions.length > 1 && <BodyS color="var(--c-neutral-600)">{hint}</BodyS>
    );
  }

  return null;
};
